// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import HomePage from './components/Home';
import Header from './components/Header';
import Resume from './Resume';
import Footer from './components/Footer';
import Blog from './components/Blog';
import BlogIITH from './components/MtechBlog';
import ContactMe from './components/contact';

function Home() {
  return (
    <>
      <Header />
      <main className="container mx-auto px-4 py-12">
        <HomePage />
      </main>
      <Footer />
    </>
  );
}

function CVPage() {
  return (
    <>
      <Header />
      <main className="container mx-auto px-4 py-12">
        <Resume />
      </main>
      <Footer />
    </>
  );
}

function BlogPage() {
  return (
    <>
      <Header />
      <main className="container mx-auto px-4 py-12">
        <Blog />
      </main>
      <Footer />
    </>
  );
}

function BlogIITHPage() {
  return (
    <>
      <Header />
      <main className="container mx-auto px-4 py-12">
        <BlogIITH />
      </main>
      <Footer />
    </>
  );
}

function ContactMePage() {
  return (
    <>
      <Header />
      <main className="container mx-auto px-4 py-12">
        <ContactMe />
      </main>
      <Footer />
    </>
  );
}

// Main App component
function App() {
  return (
    <Router>
      <div className="bg-gray-100 min-h-screen font-sans text-gray-800">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cv" element={<CVPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/mtechcse@iith" element={<BlogIITHPage />} />
          <Route path="/contact" element={<ContactMePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
